import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

const BookCtx = createContext(null);

export function BookProvider({ children }) {
  const [bookId, setBookIdState] = useState(localStorage.getItem("zor_book") || "");
  const [book, setBook] = useState(null);
  const [books, setBooks] = useState([]);

  const loadBooks = useCallback(async () => {
    const { data } = await api.get("/books");
    setBooks(data);
    return data;
  }, []);

  const refresh = useCallback(async (id) => {
    const target = id || bookId;
    if (!target) return null;
    const { data } = await api.get(`/books/${target}`);
    setBook(data);
    return data;
  }, [bookId]);

  useEffect(() => {
    loadBooks().then((list) => {
      if (!list.length) return;
      if (!bookId || !list.find((b) => b.id === bookId)) {
        setBookIdState(list[0].id);
        localStorage.setItem("zor_book", list[0].id);
      }
    });
  }, []); // eslint-disable-line

  useEffect(() => { if (bookId) refresh(bookId).catch(() => {}); }, [bookId]); // eslint-disable-line

  const setBookId = (id) => { localStorage.setItem("zor_book", id); setBookIdState(id); };

  return <BookCtx.Provider value={{ bookId, setBookId, book, setBook, refresh, books, loadBooks }}>{children}</BookCtx.Provider>;
}

export const useBook = () => useContext(BookCtx);

export function useJob(onDone) {
  const [job, setJob] = useState(null);
  const timer = useRef(null);
  const doneRef = useRef(onDone);
  doneRef.current = onDone;

  const track = useCallback((j) => {
    setJob(j);
    clearInterval(timer.current);
    timer.current = setInterval(async () => {
      const { data } = await api.get(`/jobs/${j.id}`);
      setJob(data);
      if (["Hazır", "Başarısız"].includes(data.status)) {
        clearInterval(timer.current);
        doneRef.current?.(data);
      }
    }, 3000);
  }, []);

  useEffect(() => () => clearInterval(timer.current), []);
  const running = job && !["Hazır", "Başarısız"].includes(job.status);
  return { job, track, running };
}
